import { DatePipe } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { CDN_URL } from '@maximizer/core/shared/domain';
import { EmbeddedComponent } from '@maximizer/core/shared/ui/components/base';
import { UI_PIPES } from '@maximizer/core/shared/ui/pipes';
import { OpportunityService } from '@maximizer/outlook/opportunity/data-access';
import { OutlookStore } from '@maximizer/outlook/shared/data-access';
import { OpportunitySummary } from '@maximizer/outlook/shared/domain';
import { OUTLOOK_SHARED_UI } from '@maximizer/outlook/shared/ui';
import { TranslatePipe } from '@ngx-translate/core';
import { catchError, finalize } from 'rxjs';

@Component({
  selector: 'maximizer-summary-opportunity',
  templateUrl: './summary-opportunity.component.html',
  imports: [DatePipe, OUTLOOK_SHARED_UI, TranslatePipe, UI_PIPES],
})
export class SummaryOpportunityComponent
  extends EmbeddedComponent
  implements OnInit
{
  @Output() loadErrorEvent: EventEmitter<string> = new EventEmitter();
  @Output() loadingEvent: EventEmitter<boolean> = new EventEmitter();

  @Input() deepLink?: string;
  @Input() id = '';

  configuration: OpportunitySummary;
  loading = true;
  oppLink?: string;
  isOverdue = false;

  constructor(
    @Inject(CDN_URL) public cdn: string,
    element: ElementRef,
    private readonly opportunityService: OpportunityService,
    public outlookStore: OutlookStore,
  ) {
    super(element);
    this.configuration = {
      opportunitiesAmount: 0,
      opportunitiesWorthValue: 0,
    };
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this.opportunityService
      .getSummary(this.id)
      .pipe(
        catchError(async () => this.loadErrorEvent.emit('opportunity')),
        finalize(() => {
          this.loadingEvent.emit(false);
          this.loading = false;
        }),
      )
      .subscribe((data) => {
        if (!data) return;

        this.configuration = data;
        this.checkIfOverdue();
      });
  }

  checkIfOverdue(): void {
    if (!this.configuration?.opportunity?.closeDate) return;
    const closeDate = new Date(this.configuration.opportunity.closeDate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    this.isOverdue = closeDate < today;
  }
}
